
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/451",
      function () {
        return require("private-next-pages/451.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/451"])
      });
    }
  